module.exports = __webpack_public_path__ + "d4bcc095de3b1da186e29221858e418d.png";